import { StoreBadges } from "@/components/StoreBadges";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="bg-[#14213D] py-24 px-6 md:px-12 relative overflow-hidden">
    <div className="stamp-watermark" style={{ backgroundImage: "url(/assets/veristamp_icon_master.svg)", backgroundPosition: "-10% 120%" }} />
    <div className="max-w-4xl mx-auto text-center relative">
      <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F7F6F2]">
        Your next move deserves <span className="text-[#C9A227]">proof.</span>
      </h2>
      <p className="mt-5 text-base text-[#F7F6F2]/70">
        Free to capture. Certified when it counts. Available on iPhone and Android.
      </p>
      <div className="mt-10 flex justify-center">
        <StoreBadges idPrefix="cta" />
      </div>
    </div>
  </section>
);
